import { render, staticRenderFns } from "./RDNumericBox.vue?vue&type=template&id=3a8d0b1b&scoped=true&"
import script from "./RDNumericBox.vue?vue&type=script&lang=js&"
export * from "./RDNumericBox.vue?vue&type=script&lang=js&"
import style0 from "./RDNumericBox.vue?vue&type=style&index=0&id=3a8d0b1b&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3a8d0b1b",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VRow } from 'vuetify/lib/components/VGrid';
import { VTooltip } from 'vuetify/lib/components/VTooltip';
installComponents(component, {VRow,VTooltip})
